import ConfigManager from "@/config/ConfigManager";
import Utility from "@/helper/Utility";
import BlobService from "../Blob/service/BlobService";

export default {
    getBaseUrl: function () {
        var api = Utility.getParameterByName("api");
        var strUrl = ConfigManager.getApiUrl()

        if (!api) {
            return strUrl;
        }
        strUrl = "https://" + api + ".buzzebees.com";
        return strUrl;
    },

    getBlobWeblandingConfig: function (app_id) {
        var blob_path;
        if (app_id) {
            blob_path = "config/weblanding/" + app_id + ".json";
        }
        else {
            blob_path = "config/weblanding/default.json"; 
        }
        // console.log(blob_path)
        var url = ConfigManager.getBlobUrl();
        return BlobService.apiGetConfig(url, blob_path);
    },

    getBlobWeblandingConfigDescription: function (app_id) {
        if (app_id) {
            var blob_path;
            blob_path = "config/weblanding/" + app_id + "/description.json";
            // console.log(blob_path)
            var url = ConfigManager.getBlobUrl();
            return BlobService.apiGetConfig(url, blob_path);
        }
    },

    getBlobWeblandingConfigByBlobPath: function (blob_path) {
        var url = ConfigManager.getBlobUrl();
        return BlobService.apiGetConfig(url, blob_path);
    },

    getBlobAppThemeMapping: function () {
        var blob_path = "config/weblanding/app_mapping.json";

        var url = ConfigManager.getBlobUrl();
        return BlobService.apiGetConfig(url, blob_path);
    },
}
